import angular from 'angular';
import './modals/modal-delete-principal.component.js';
import EnvelopeFilters from '../../epdf-app/dashboard/envelope/envelope-filters.data';

class principalDetailCtrl {
    /* @ngInject */
    constructor(
        $state,
        logger,
        PrincipalSvc,
        AuthSvc,
        $uibModal,
        PRINCIPAL,
        PrincipalPlatform,
        EnvelopeService,
        PrincipalService,
        EMAIL_REGEXP
    ) {
        this.EnvelopeService = EnvelopeService;
        this.$state = $state;
        this.logger = logger;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
        this.PRINCIPAL = PRINCIPAL;
        this.PrincipalPlatform = PrincipalPlatform;
        this.PrincipalService = PrincipalService;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
    }

    $onInit() {
        this.resetPrincipal = angular.copy(this.principal);

        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };

        // Init des données
        this.langs = this.PrincipalSvc.getLangs();
        this.plateforms = this.PrincipalSvc.getPlateforms();
        this.plateforms.splice(this.plateforms.indexOf('ALL'), 1);

        // Profil choisit sur l'écran
        this.principalProfil;

        this.PrincipalSvc.updateMenuConsult();
        this.doHasEpdfContainers = false;
        // boolean pour dire si on peut modifier la Plateforme de réception des documents traités par ePDF ou non
        this.principalDematPlatformEditable = true;
        /** GIS :  si on peut modifier  la selection de la platforme ,la référence sur la plateforme
         * et le sens de démat entrante
         */
        this.gisPlatformEditable = true;
        /** PASREL : si on peut modifier  la selection de la platforme ,la référence sur la plateforme
         * et le sens de démat entrante
         */
        this.pasrelPlatformEditable = true;

        /** NETIX : si on peut modifier  la selection de la platforme ,la référence sur la plateforme
         * et le sens de démat entrante
         */
        this.netixPlatformEditable = false;

        if (!this.create) {
            this.isPrincipalDeletable();
            this.isPrincipalDematPlatformEditable();
        }

        this.initPrincipalDematPlatforms();

        this.initProfil();

        this.reportFrequencies = this.PrincipalSvc.getReportFrequencies();
        this.searchContainersForDo();
    }
    $onDestroy() {
        this.PrincipalSvc.setAdmin(null);
    }

    searchContainersForDo() {
        this.hasContainers = false;
        if (this.principal.detail.id && this.principal.detail.profilBuyer) {
            this.PrincipalService.countCompanyContainer([this.principal.detail.id], data => {
                this.hasContainers = data[0].nbContainer > 0;
            });
        }
    }

    isInvInErrorReportActivated() {
        return this.principal.detail.invInErrorReportFrequency !== this.PRINCIPAL.reportFrequencies[3]; // NEVER
    }

    /**
     * Permet d'initialiser les variables pour la gestion des plateformes de démat
     */
    initPrincipalDematPlatforms() {
        this.gisPlatform = new this.PrincipalPlatform();
        this.pasrelPlatform = new this.PrincipalPlatform();
        this.netixPlatform = new this.PrincipalPlatform();

        this.gisPlatform.family = 'GIS';
        this.pasrelPlatform.family = 'PASREL';
        this.netixPlatform.family = 'NETIX';

        this.pasrelPlatform.platformEid = 'PASREL';
        this.netixPlatform.platformEid = 'NETIX';

        this.gisPlatformSelected = false;
        this.pasrelPlatformSelected = false;
        this.netixPlatformSelected = false;

        if (!this.create || this.principal != null) {
            if (this.principal.detail.dematPlatforms.length > 0) {
                this.principal.detail.dematPlatforms.forEach(element => {
                    if (element.family === 'GIS') {
                        this.gisPlatform = element;
                        this.gisPlatformSelected = true;
                        this.gisPlatformEid = this.allDematPlatforms['GIS'].find(
                            plat => plat.value === element.platformEid
                        );
                    } /* PASREL */ else if (element.family === 'PASREL') {
                        this.pasrelPlatform = element;
                        this.pasrelPlatformSelected = true;
                    } /* Netix */ else if (element.family === 'NETIX') {
                        this.netixPlatform = element;
                        this.netixPlatformSelected = true;
                    }
                    if (
                        (this.gisPlatformSelected || this.pasrelPlatformSelected) &&
                        this.principal.detail.profilSeller
                    ) {
                        this.netixPlatformEditable = true;
                    }
                });
            }
        }
        this.updateDematSensVisibility();
        this.updateEpdfFieldVisibilty();
    }
    gisSelectionChange() {
        this.gisPlatform = this.handlePlatfromSelectionChange(
            this.gisPlatform,
            this.gisPlatformSelected,
            this.gisPlatformEditable
        );
        this.handlenetixPlatformEdition();
    }

    pasrelSelectionChange() {
        this.pasrelPlatform = this.handlePlatfromSelectionChange(
            this.pasrelPlatform,
            this.pasrelPlatformSelected,
            this.pasrelPlatformEditable
        );

        this.handlenetixPlatformEdition();
    }
    netixSelectionChange() {
        this.netixPlatform = this.handlePlatfromSelectionChange(
            this.netixPlatform,
            this.netixPlatformSelected,
            this.netixPlatformEditable
        );
    }

    handlenetixPlatformEdition() {
        this.netixPlatformEditable =
            (this.gisPlatformSelected || this.pasrelPlatformSelected) && this.principal.detail.profilSeller;
        if (!this.netixPlatformEditable) {
            this.netixPlatform = new this.PrincipalPlatform();
            this.netixPlatformSelected = false;
            this.netixPlatform.family = 'NETIX';
            this.netixPlatform.platformEid = 'NETIX';
        }
    }

    /**
     *
     * @param {*} platform la plateforme de demat
     * @param {*} isPlatformSelected : boolean pour dire si la plateforme est selectionnée ou non
     */
    handlePlatfromSelectionChange(platform, isPlatformSelected, isPlateformEditable) {
        this.updatePlatformWhenDoProfileChange(platform, isPlateformEditable, isPlatformSelected);

        if (!isPlatformSelected) {
            this.principal.detail.dematPlatforms.splice(this.findPlatformIndex(platform), 1);
            var platformName = platform.family;
            platform = new this.PrincipalPlatform();
            platform.family = platformName;
        } else {
            this.principal.detail.dematPlatforms.push(platform);
        }

        this.updateDematSensVisibility();
        if (this.principalDematPlatformEditable) {
            this.updateEpdfFieldVisibilty();
        }

        return platform;
    }
    findPlatformIndex(platform) {
        var platformIndex;
        this.principal.detail.dematPlatforms.forEach((principalPlatform, index) => {
            if (principalPlatform.family === platform.family) {
                platformIndex = index;
            }
        });
        return platformIndex;
    }
    /**
     * Permet de vérifier si on affiche la partie Plateforme de réception ePDF
     * et met à jour la liste des plateformes
     */
    updateEpdfFieldVisibilty() {
        if (this.principal.detail.profilSeller && !this.principal.detail.profilBuyer) {
            /** Si le DO est seulement fournisseur on doit initialiser la plateforme de réception des documents traités par ePDF
             */
            this.showEpdfPlatform = false;
            this.principal.detail.plateform = this.pasrelPlatformSelected ? 'PASREL' : 'GIS';
        } else {
            if (this.principalHasAtLeastOneDematOut()) {
                this.showEpdfPlatform = true;
            } else {
                this.showEpdfPlatform = false;
            }
        }
        this.updatePlatformsList();
    }
    /**
     * Met à jour la liste des plateforme pour la partie Plateforme de réception ePDF
     */
    updatePlatformsList() {
        if (this.principalDematPlatformEditable) {
            var platforms = [];
            if (this.gisPlatform.invoiceRe) {
                this.principal.detail.plateform = 'GIS';
                platforms.push('GIS');
            }
            if (this.pasrelPlatform.invoiceRe) {
                platforms.push('PASREL');
                if (!this.gisPlatform.invoiceRe) {
                    this.principal.detail.plateform = 'PASREL';
                }
            }
            this.plateforms = platforms;
        }
    }

    /**
     * Teste si la platforme de dématérialisation sélectionnée est modifiable
     */
    isPrincipalDematPlatformEditable() {
        this.PrincipalSvc.hasAcceptedInvitations(this.principal.detail.id).then(result => {
            if (!result) {
                this.checkIfDoHasEpdfContainersEnvelopes().$promise.then(element => {
                    if (element.length > 0) {
                        this.principalDematPlatformEditable = false;
                        this.updateDematPlatformEditable();
                    }
                });
            } else {
                this.principalDematPlatformEditable = false;
                this.updateDematPlatformEditable();
            }
        });
    }
    updateDematPlatformEditable() {
        if (!this.principalDematPlatformEditable) {
            if (this.principal.detail.plateform === 'GIS') {
                this.gisPlatformEditable = false;
            } else {
                this.pasrelPlatformEditable = false;
            }
        }
    }
    /**
     * Permet de vérifier s'il y a des plis ratachés a des containers ePDF pour le do.
     */
    checkIfDoHasEpdfContainersEnvelopes() {
        var criterias = new EnvelopeFilters();
        criterias.containerMode = 'STANDARD';
        criterias.setPrincipalId(this.PrincipalSvc.getPrincipalId());
        return this.EnvelopeService.searchByCriterias(criterias);
    }
    /**
     * Permet de mettre à jour  la selection des sens de démat pour une platforme
     * quand le profil do change
     * @param {*} platform: la plateforme à mettre à jour
     */
    updatePlatformWhenDoProfileChange(platform, platformEditable, isPlatformSelected) {
        platform.orderRe = false;
        platform.orderEm = false;
        if (platform.family === 'NETIX') {
            platform.invoiceEm = false;
            platform.invoiceRe = false;
        } else if (platformEditable) {
            platform.orderRe = false;
            if (!isPlatformSelected || (this.principal.detail.profilBuyer && this.principal.detail.profilSeller)) {
                platform.invoiceEm = false;
                platform.invoiceRe = false;
            } else if (this.principal.detail.profilBuyer) {
                platform.invoiceEm = false;
                platform.invoiceRe = true;
            } else if (this.principal.detail.profilSeller) {
                platform.invoiceEm = true;
                platform.invoiceRe = false;
            }
        } else {
            if (this.principal.detail.profilSeller && this.principal.detail.profilBuyer) {
                platform.invoiceEm = false;
            } else if (this.principal.detail.profilSeller) {
                platform.invoiceEm = true;
            } else {
                platform.invoiceEm = false;
            }
        }
    }
    /**
     * Permet de  mettre à jour les plateformes de demat quand le profil do change
     *
     */
    updatePlatformsDoProfileChange() {
        if (this.pasrelPlatformSelected) {
            this.updatePlatformWhenDoProfileChange(
                this.pasrelPlatform,
                this.pasrelPlatformEditable,
                this.pasrelPlatformSelected
            );
        }
        if (this.gisPlatformSelected) {
            this.updatePlatformWhenDoProfileChange(
                this.gisPlatform,
                this.gisPlatformEditable,
                this.gisPlatformSelected
            );
        }
        if (this.netixPlatformSelected) {
            this.updatePlatformWhenDoProfileChange(
                this.netixPlatform,
                this.netixPlatformEditable,
                this.netixPlatformSelected
            );
        }
        this.handlenetixPlatformEdition();
        this.updateDematSensVisibility();
        this.updateEpdfFieldVisibilty();
    }
    updateDematSensVisibility() {
        if (this.principal.detail.profilBuyer && this.principal.detail.profilSeller) {
            this.disableDematOut = false;
            this.disableDematIn = false;
            this.disableDematOrderOut = false;
            this.disableDematOrderIn = false;
        } else {
            this.disableDematOut = true;
            this.disableDematIn = true;
            if (this.principal.detail.profilBuyer) {
                this.disableDematOrderIn = true;
                this.disableDematOrderOut = false;
            } else if (this.principal.detail.profilSeller) {
                this.disableDematOrderIn = false;
                this.disableDematOrderOut = true;
            }
        }
    }

    /**
     * Permet de vérifier si le DO a au moins un sens de dématérialisation entrante
     */
    principalHasAtLeastOneDematOut() {
        if (this.gisPlatformSelected || this.pasrelPlatformSelected) {
            if (this.principal.detail.profilBuyer && this.principal.detail.profilSeller) {
                return this.gisPlatform.invoiceRe || this.pasrelPlatform.invoiceRe;
            } else if (this.principal.detail.profilBuyer) {
                return true;
            } else if (this.principal.detail.profilSeller) {
                return false;
            }
        } else {
            return false;
        }
    }
    /**
     * Permet de vérifier si le DO a au moins un sens de dématérialisation sortante
     */
    principalHasAtLeastOneDematIn() {
        if (this.gisPlatformSelected || this.pasrelPlatformSelected) {
            if (this.principal.detail.profilBuyer && this.principal.detail.profilSeller) {
                return this.gisPlatform.invoiceEm || this.pasrelPlatform.invoiceEm;
            } else if (this.principal.detail.profilBuyer) {
                return false;
            } else if (this.principal.detail.profilSeller) {
                return true;
            }
        } else {
            return false;
        }
    }
    initProfil() {
        if (this.principal.detail.profilBuyer && this.principal.detail.profilSeller) {
            this.principalProfil = this.PRINCIPAL.profil.buyerSeller;
        } else if (this.principal.detail.profilSeller) {
            this.principalProfil = this.PRINCIPAL.profil.seller;
        } else {
            this.principalProfil = this.PRINCIPAL.profil.buyer;
        }
        this.onChangeProfil();
    }
    /**
     * controle la sélection des plateformes de démat suivant le profil DO sélectionné
     */
    checkDematPlatformsSelection() {
        if (!this.gisPlatformSelected && !this.pasrelPlatformSelected) {
            this.platformErrorMessage = 'principal.detail.must_select_demat_platform';
            return false;
        } else if (
            this.principal.detail.profilBuyer &&
            this.principal.detail.profilSeller &&
            (this.gisPlatformSelected || this.pasrelPlatformSelected) &&
            (!this.principalHasAtLeastOneDematIn() || !this.principalHasAtLeastOneDematOut())
        ) {
            this.platformErrorMessage = 'principal.detail.must_select_demat_sens';
            return false;
        }
        this.platformErrorMessage = '';
        return true;
    }

    /**
     * controle la cohérence des donnèes saisies avec la plateforme GIS
     */
    checkGisCompanyDetail() {
        if (this.form.$valid && this.checkDematPlatformsSelection()) {
            this.platformErrorMessage = '';
            if (this.gisPlatformSelected) {
                this.gisPlatform.platformEid = this.gisPlatformEid.value;
                this.PrincipalSvc.checkGisCompanyDetail(this.gisPlatform.platformEid, this.principal.detail.eid).then(
                    data => {
                        if (
                            data.customer !== this.gisPlatform.pcpEidOnPlatform ||
                            data.dematDirection !== this.mapProfilDo(this.gisPlatform) ||
                            data.label !== this.principal.detail.corporateName
                        ) {
                            this.$uibModal
                                .open({
                                    component: 'controlCreateDoModal',
                                    size: 'md',
                                    resolve: {
                                        modalTitle: () => {
                                            return {
                                                value: 'Les données suivantes ne sont pas cohérentes',
                                            };
                                        },
                                        modalMessage: () => {
                                            return {
                                                data: data,
                                                principalId: this.principal.detail.eid,
                                                platformId: this.gisPlatform.pcpEidOnPlatform,
                                                principalProfil: this.principalProfil,
                                                principalRaison: this.principal.detail.corporateName,
                                                platformEid: this.gisPlatform.platformEid,
                                            };
                                        },
                                        modalCancelButtonText: () => {
                                            return { value: 'Modifier la saisie' };
                                        },
                                        modalConfirmButtonText: () => {
                                            return { value: 'Confirmer' };
                                        },
                                    },
                                    backdrop: 'static',
                                    keyboard: false,
                                })
                                .result.then(
                                    () => (this.create === true ? this.next() : this.update()),
                                    () => {}
                                );
                        } else {
                            this.create === true ? this.next() : this.update();
                        }
                    },
                    () => {}
                );
            } else {
                this.create === true ? this.next() : this.update();
            }
        }
    }

    next() {
        this.PrincipalSvc.checkDuplicateEid(this.principal.detail.eid).then(
            () => {
                this.PrincipalSvc.checkDuplicateAppId(this.principal.detail.appId).then(
                    () => {
                        this.PrincipalSvc.setPrincipal(this.principal);
                        // appel au serveur pour valider les données ?
                        // quand on reviens à la page précédente si form dirty on supprime le
                        // tick de l'étape actuelle
                        // enrtegistrer dans le service les données
                        this.PrincipalSvc.changeCreationStep(1, 2);
                        this.$state.go('app.principal.create.configportal', { eid: this.principal.detail.eid });
                    },
                    error => {
                        // AppID déjà utilisé
                        if (error.status === 400 && error.data && error.data.code === 'DUPLICATE_PRINCIPAL_APPID') {
                            this.form.appId.$setValidity('appidAlreadyUsed', false);
                        }
                    }
                );
            },
            error => {
                // EID déjà utilisé

                if (error.status === 400 && error.data && error.data.code === 'DUPLICATE_PRINCIPAL_EID') {
                    this.form.eid.$setValidity('eidAlreadyUsed', false);
                }
            }
        );
    }

    fieldChange(name) {
        if (name === 'eid') {
            if (this.form.eid.$error.eidAlreadyUsed) {
                this.form.eid.$setValidity('eidAlreadyUsed', true);
            }
        } else {
            if (this.form.appId.$error.appidAlreadyUsed) {
                this.form.appId.$setValidity('appidAlreadyUsed', true);
            }
        }
    }

    update() {
        if (this.form.$valid && this.checkDematPlatformsSelection()) {
            this.PrincipalSvc.updatePrincipal(this.principal).then(
                data => {
                    this.form.$setPristine();
                    this.logger.success('success.update', data, null, {
                        entityName: "Le Donneur d'ordre",
                    });
                },
                error => {
                    this.logger.error('error.update', error);
                }
            );
        }
    }

    cancel() {
        this.principal = angular.copy(this.resetPrincipal);
        this.initProfil();
        this.principal.detail.setCountry(this.countries);
        this.initPrincipalDematPlatforms();
        this.form.$setPristine();
    }

    /**
     * Teste si le DO est supprimable.
     */
    isPrincipalDeletable() {
        this.PrincipalSvc.isPrincipalDeletable(this.principal.detail.id).then(result => {
            this.principalDeletable = result;
        });
    }

    /**
     * Supression de la société.
     */
    deletePrincipal() {
        this.$uibModal
            .open({
                component: 'modalDeletePrincipal',
                size: 'lg',
                resolve: {
                    principal: () => {
                        return this.principal.detail;
                    },
                },
            })
            .result.then(
                () => {
                    this.$state.go('do', { tabName: 'principal' });
                },
                () => {}
            );
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    /**
     * Met à jour l'objet Principal.detail lors du changement de profil.
     */
    onChangeProfil() {
        if (this.principalProfil === this.PRINCIPAL.profil.buyerSeller) {
            this.principal.detail.profilBuyer = true;
            this.principal.detail.profilSeller = true;
        } else if (this.principalProfil === this.PRINCIPAL.profil.buyer) {
            this.principal.detail.profilBuyer = true;
            this.principal.detail.profilSeller = false;
            if (this.principal.detail.processO2c) {
                this.principal.detail.processO2c = false;
            }
        } else {
            this.principal.detail.profilBuyer = false;
            this.principal.detail.profilSeller = true;
            if (this.principal.detail.processP2p) {
                this.principal.detail.processP2p = false;
            }
        }
    }
    doProfileChange() {
        this.onChangeProfil();

        this.updatePlatformsDoProfileChange();
    }
    mapProfilDo(dematPlatform) {
        if (dematPlatform.invoiceRe && !dematPlatform.invoiceEm) {
            return 'RECEIVER';
        } else if (!dematPlatform.invoiceRe && dematPlatform.invoiceEm) {
            return 'SENDER';
        } else {
            return 'TWO_WAY_DEMAT';
        }
    }

    backList() {
        this.$state.go('do', { tabName: 'principal' });
    }

    isEmail(value) {
        // Regexp utilisé dans Angular pour valider les input[type=email]
        return this.EMAIL_REGEXP.test(value.text);
    }
}

angular.module('app.principal').component('principalDetail', {
    templateUrl: require('./principal-detail.html'),
    controller: principalDetailCtrl,
    bindings: {
        countries: '<',
        ladProviders: '<',
        principal: '<',
        create: '<',
        initMenuConsult: '<',
        allDematPlatforms: '<',
    },
});
